//Handlebars helper to allow basic loop functionality
//https://stackoverflow.com/questions/11924452/iterating-over-basic-for-loop-using-handlebars-js
const loop = (n, block) => {
    let accumulator = '';
    for (var i = 0; i < n; i++) {
        accumulator += block.fn(i);
    }
    return accumulator;
};

module.exports = loop;


// WEBPACK FOOTER //
// ./shared/templates/helpers/loop.helper.js